import { render, staticRenderFns } from "./BioSocialLinkCard.vue?vue&type=template&id=5228edd3&scoped=true&"
import script from "./BioSocialLinkCard.vue?vue&type=script&lang=js&"
export * from "./BioSocialLinkCard.vue?vue&type=script&lang=js&"
import style0 from "./BioSocialLinkCard.vue?vue&type=style&index=0&id=5228edd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228edd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
